module.exports = __webpack_public_path__ + "img/img-issue-qrcode.6adeb4e3.png";